var _defs, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenchmarkComparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.17 17.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#32a590;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.59,
    cy: 8.59,
    r: 8.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.38,393.76l.72-.72,1.13-1.13.26-.26h-1l.72.72,1.13,1.13.27.26a.66.66,0,0,0,.48.2.69.69,0,0,0,.48-.2.71.71,0,0,0,.19-.48.66.66,0,0,0-.19-.48l-.72-.71L303.75,391l-.26-.26a.69.69,0,0,0-1,0l-.71.72-1.14,1.13-.26.26a.72.72,0,0,0-.2.48.7.7,0,0,0,.2.48.67.67,0,0,0,.48.2.72.72,0,0,0,.48-.2Z",
    transform: "translate(-297.16 -387.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.33,391.17V399h0a.72.72,0,0,0,.2.48.67.67,0,0,0,.48.2.7.7,0,0,0,.48-.2.67.67,0,0,0,.2-.48v-7.83h0a.67.67,0,0,0-.2-.48.66.66,0,0,0-.48-.2.74.74,0,0,0-.48.2.72.72,0,0,0-.2.48Z",
    transform: "translate(-297.16 -387.18)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.87,399.09l.72.72,1.13,1.13.26.26a.69.69,0,0,0,1,0l.72-.71,1.14-1.14.26-.26a.7.7,0,0,0,.2-.48.74.74,0,0,0-.2-.48.68.68,0,0,0-1,0l-.72.72L308.25,400l-.27.26h1l-.72-.71-1.14-1.14-.26-.26a.7.7,0,0,0-.48-.2.74.74,0,0,0-.48.2.68.68,0,0,0,0,1Z",
    transform: "translate(-297.16 -387.18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.14,400.72v-7.84a.69.69,0,0,0-.2-.48.71.71,0,0,0-.48-.19.66.66,0,0,0-.48.19.74.74,0,0,0-.2.48v7.83h0a.7.7,0,0,0,.2.48.67.67,0,0,0,.48.2.66.66,0,0,0,.48-.2.7.7,0,0,0,.2-.48Z",
    transform: "translate(-297.16 -387.18)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkComparator);
export default __webpack_public_path__ + "static/media/benchmark_comparator.ce3d1918a12cc2bec1e004c4c1eb6a02.svg";
export { ForwardRef as ReactComponent };